var helpCenter = {

    init:function(){
		var startingHash = window.location.hash.substring(1);	
		var $partial = $('#helpCenter');
		$(window).on('hashchange', function() {
			$('.helpcenter-nav .nav-widget-content  .nav-pills li a[href="'+window.location.hash+'"]').trigger('click');
			$partial.data('type',startingHash);
			$('.helpcenter-nav .nav-widget-content  .nav-pills li').removeClass('active');
			$('.helpcenter-nav .nav-widget-content  .nav-pills li a[href="'+window.location.hash+'"]').parent().addClass('active');
			load_partial($partial);
			return false;	
		});	

		if(startingHash!==''){
			setTimeout(function(){
				$('.helpcenter-nav .nav-widget-content  .nav-pills li a[href="'+window.location.hash+'"]').trigger('click');
				$partial.data('type',startingHash);
				$('.helpcenter-nav .nav-widget-content  .nav-pills li').removeClass('active');
				$('.helpcenter-nav .nav-widget-content  .nav-pills li a[href="'+window.location.hash+'"]').parent().addClass('active');
				load_partial($partial);
			},500);
			
		}
    },
 
	form:function(form){
		$('#help-center-search-form').on('submit',function(){
			var $this  = $(this).find('input[name="q"]');
			var $partial = $('#helpCenter');
			var $val  = $this.val();
			var $type = $partial.data('type');
			$partial.data('q',$val);
			$partial.data('type','how-to-article,how-to-videos,product-manuals');
			$('.helpcenter-nav .nav-widget-content  .nav-pills li').removeClass('active');
			load_partial($partial);
			return false;		
		});
	}
};